module.exports = "<div class=\"font-weight-bold container-fluid\">\n  <app-kegs class=\"font-weight-normal\"></app-kegs>\n</div>\n"